import { BASE_PATH } from '../utils/basePath';

export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export async function getFaqs(): Promise<FaqItem[]> {
  const res = await fetch(`${BASE_PATH}/api/faqs`, { credentials: 'include' });
  if (!res.ok) throw new Error('Failed to fetch FAQs');
  const data = await res.json();
  return data.records || [];
}
